<script lang="ts">
    import StatisticSelector from './StatisticSelector.svelte';
    import StatisticsValue from './StatisticsValue.svelte';
    import {
        MEASUREMENT_FIELD_DELAY_DURATION
    } from "../../constants/measurement-table-constants";
    import type {RouteMeasurements} from "../../models/route-measurements.model";
    import {getStatisticsSet} from "../../helpers/statistics.helper";
    import {routeInfoStore} from "../../stores/route-info.store";
    import type {IRouteInfo} from "../../utils/types";
    import type {StatisticsSet} from "../../types/statistics/statistics-set.type";
    import type {Statistic} from "../../types/statistics/statistic.type";
    import {getMeasurementFieldDescription, getMeasurementFieldLabel} from "../../i18n/translate";
    
    
    export let selectMeasurementProperty: (measurementProperty: string | null) => void;
    export let routeMeasurementsFiltered: RouteMeasurements[];
    let selectedMeasurementProperty: string | null = MEASUREMENT_FIELD_DELAY_DURATION;

    const handleIndicatorSelected = (event: CustomEvent<string | null>) => {
        selectedMeasurementProperty = event.detail;
        selectMeasurementProperty(selectedMeasurementProperty);
    };
    
    $: selectedStatisticSet = getStatsForMeasurementProperty(routeMeasurementsFiltered, selectedMeasurementProperty, $routeInfoStore);
    $: statistics = filterOutUndefinedStatistics(selectedStatisticSet);
    
    function filterOutUndefinedStatistics(set: StatisticsSet): Statistic[] {
        const allStatistics = [
            set.average,
            set.median,
            set.min,
            set.max
        ];
        return allStatistics.filter(stat => stat !== undefined);        
    }
    
    function getStatsForMeasurementProperty(routeMeasurements: RouteMeasurements[], propertyName: string, routeInfo: {[key in string]: IRouteInfo}): StatisticsSet {
        const valueList = routeMeasurements.filter(measurement => !routeInfo[measurement.routeId].hidden)
            .map(measurement => measurement[propertyName]);
        
        return getStatisticsSet(propertyName, valueList)
    }
</script>

<div>
    <div class="card">
        <div class="card-content">
            <div class="statistics">
                <div>
                    <StatisticSelector on:indicatorSelected={handleIndicatorSelected} {selectedMeasurementProperty} />
                </div>
                {#each statistics as stat, i}
                    <StatisticsValue statistic={stat} />
                {/each}
            </div>
            <div class="statistics">
                <br>
                <span>
                    {
                        selectedStatisticSet?.description !== null 
                            ? getMeasurementFieldDescription(selectedStatisticSet?.propertyName)
                            : ''
                    }
                </span>
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    .card-content {
        display: flex;
        flex-direction: column;
        padding: 16px;
    }

    .label {
        margin-bottom: 8px;
    }

    title {
      font-size: 16px;
      color: var(--f7-text-color, #000);
      font-weight: bold;
    }

    .statistics {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: space-between;
    }
</style>
